'use client';

import { useEffect } from 'react';

export const usePreloadImages = (input: ReadonlyArray<string>) => {
  useEffect(() => {
    input.forEach((e) => {
      const image = new Image();
      image.src = e;
      image.decode();
    });
  }, []);
};
